<div class="snickers-page-container" [ngClass]="{'rtl': (langChosen=='ar')?true:false}">
  <div class="flex_block">
    <div class="character hidden-sm hidden-xs">
      <img src="assets/img/snickers/character.png" alt="">
    </div>
    <div class="text">
      <h1>
        About Snickers <span class="red">Ultimate E-Cup</span> Tournament
      </h1>
      <p>
        It is a long established fact that a reader will be distracted by the readable content of a page when
        looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
        distribution of letters, as opposed to using 'Content here, content here',
        making it look like readable English. Many desktop publishing packages and web page editors
        now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover
        many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like). There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly
      </p>
    </div>

  </div>
</div>


